import React, { useState, useEffect } from "react";
import { DatePicker } from 'antd';
import { PushSpinner } from "react-spinners-kit";
import { BASE_URL, fromdate } from './apiConfig';
import { RotateSpinner } from "react-spinners-kit";
import Swal from 'sweetalert2';
import './CommonCSS.css'


export default function Detailedreport() {

    const [DetailedapiData, setDetailedapiData] = useState('');
    const [showprogress, setshowprogress] = useState(false);
    const [guiuser, setguiuser] = useState('');
    const { RangePicker } = DatePicker;
    const [DistinctAPIData, setDistinctAPIData] = useState([]);
    const [DistinctIPData, setDistinctIPData] = useState([]);
  const [distinctSeller, setdistinctSeller] = useState([]);
    const [distinctuser, setdistinctuser] = useState([]);
        const [seller, setseller] = useState('');
            const [apikeyvalue, setapikeyvalue] = useState('');
    const [ipvalue, setipvalue] = useState('');
    const [daterangevalue, setDateRangevalue] = useState('');
    var [currentPage, setcurrentPage] = useState(0);
    const [totalPage, setTotalPage] = useState(0);
    const [totalentry, settotalentry] = useState(0);
    const [mobilenumber, setmobilenumber] = useState('');
    const [error, setError] = useState("");
    const pageSize = 20;

    // Restrict non-numeric keys
    const handleKeyPress = (e) => {
        const allowedKeys = /^[0-9]$/; // Allow only numeric keys
        if (!allowedKeys.test(e.key)) {
            e.preventDefault();
        }
    };

    const handleMobileChange = (e) => {
        const value = e.target.value;

        // Allow mobile number to start with 6-9 and be up to 10 digits long
        const mobileRegex = /^[6-9]\d{0,9}$/;

        // Update state if the value is valid or if it's deleting digits (empty string allowed)
        if (mobileRegex.test(value) || value === '') {
            setmobilenumber(value);
        }
    };

    const [clickedIndex, setClickedIndex] = useState(null);
    const [icon, setIcon] = useState("down");

    const today = new Date();
    // Calculate yesterday's date
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    // Format yesterday's date as 'YYYY-MM-DD'
    const formattedYesterday = yesterday.toISOString().split('T')[0];

    // Set the state variables
    const [dateRange, setDateRange] = useState([formattedYesterday, formattedYesterday]);
    const [startDate, setStartDate] = useState(formattedYesterday);
    const [endDate, setEndDate] = useState(formattedYesterday);

    const handleIcon = (index) => {
        setClickedIndex((prevIndex) => (prevIndex === index ? null : index));
        setIcon((prevIcon) => (prevIcon === "down" ? "up" : "down"));
    };


    const handlePrevious = () => {
        const p = currentPage - 1;
        setcurrentPage(p);
        console.log("currentPage_inside_previous:" + currentPage);
        callDetailedReport(p);
    };

    const handleNext = () => {
        const p = currentPage + 1;
        console.log("p:" + p);
        setcurrentPage(p);
        console.log("currentPage_inside_next:" + currentPage);
        callDetailedReport(p);
    };


    const handleDateChange = (dates) => {
        // Update the state with the date range
        setDateRangevalue(dates);
        console.log("change Range" + dates);
        console.log("daterange:" + dateRange);

        const dateOnlyStrings = dates ? dates.map((dateString) => {
            const date = new Date(dateString);
            return date.toISOString().split("T")[0] || "2023-10-01";
        }) : ["2023-10-01", "2023-10-31"];

        let [sDate, eDate] = dateOnlyStrings;

        // Add one day to both start date and end date
        if (sDate) {
            const startDate = new Date(sDate);
            startDate.setDate(startDate.getDate() + 1);
            sDate = startDate.toISOString().split("T")[0];
        }

        if (eDate) {
            const endDate = new Date(eDate);
            endDate.setDate(endDate.getDate() + 1);
            eDate = endDate.toISOString().split("T")[0];
        }

        setStartDate(sDate);
        setEndDate(eDate);

        console.log("Inside start change:" + sDate);
        console.log("Inside end change:" + eDate);
    };

    const loginData = JSON.parse(sessionStorage.getItem("loginData"));
     const sessionusertype = loginData?.utype?.usertype;
    const sessionusername = loginData?.guiuserid;
        const sessionapiuser = loginData?.apiuserid;


    const apiDataLength = DetailedapiData?.length;
    const handleChange = (e) => {
        setipvalue(e.target.value);
    };
    const formatDate = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const callDetailedReport = async (p) => {
        try {
            console.log("calling detailedreport")
            setshowprogress(true);
            console.log(apikeyvalue);
            console.log("ip:" + ipvalue);
            console.log("guiuser" + guiuser);
            console.log("startdate:" + formatDate(startDate));
            console.log("enddate:" + formatDate(endDate));
            if (!apikeyvalue || !ipvalue) {
                setshowprogress(false);
                const re = await Swal.fire({
                    title: "Value Error!",
                    text: "Please Fill All Field values as either API Key or IP  field not inputted",
                    icon: "error"
                })

            }

            else if(mobilenumber!=='' && mobilenumber.length < 10)
            {
                setshowprogress(false);
                const re = await Swal.fire({
                    title: "Value Error!",
                    text: "Please Enter Valid 10 Digit Indian Mobile Number ",
                    icon: "error"
                })
            }


            else {
                const apiUrl = `${BASE_URL}/DetailedReport`;
                const requestBody = {
                    guser: {
                        requser: sessionusername,
                        guiuserid: sessionusertype === 1 ? sessionapiuser : guiuser,
                        seckey: {
                            GenertaedSkey: apikeyvalue
                        },
                    },
                    sdate: formatDate(startDate),
                    edate: formatDate(endDate),
                    ip: ipvalue,
                    mno:{
                        mobileno:mobilenumber
                    },
                    pagesize: pageSize,
                    page: p
                };
                const fetchOptions = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },

                    body: JSON.stringify(requestBody),
                };

                const response = await fetch(apiUrl, fetchOptions);
                if (!response.ok) {
                    setshowprogress(false);
                    console.log(`API request failed with status ${response.status}`);
                    setDetailedapiData([]);
                    

                    // Reset only when necessary
                } else {
                    // Successful response logic
                    const responseText = await response.text();
                    let data;
                    if (responseText) {
                        data = JSON.parse(responseText);
                    } else {
                        data = [];
                    }

                    if (data?.list?.length > 0) {
                        setDetailedapiData(data?.list);
                        const tc = data?.totalcount;
                        settotalentry(tc);
                        const totalPage = Math.ceil(tc / pageSize);

                        setTotalPage(totalPage);

                    } else {
                        setDetailedapiData([]);
                    }
                    console.log(data);
                    setshowprogress(false);
                }

            }
        }

        catch (error) {
            console.error("API Request Error:", error.message);
            setshowprogress(false);

            const result = await Swal.fire({
                title: 'API Request Error',
                html: error.message,
                icon: 'error'
            });
            if (result.isConfirmed) {
                setguiuser('');
                setapikeyvalue('');
                setDateRange([]);
                setDateRangevalue("");
            }
            return;
        }
    };

   const callDistinctGUIUser = async () => {
          let usr = "";
          if (seller !== "") {
              usr = seller;
          }
  
          else {
              usr = sessionusername;
          }
          const apiUrl = `${BASE_URL}/AllUsers?uid=${usr}&fromwhere=1`;
  
          const fetchOptions = {
              method: "GET",
              headers: {
                  "Content-Type": "application/json",
              },
          };
          setshowprogress(true);
          try {
  
              const response = await fetch(apiUrl, fetchOptions);
              setshowprogress(false);
              if (!response.ok) {
                  throw new Error(`API request failed with status ${response.status}`);
              }
  
              const data = await response.json();
  
              const filteredData = data.filter(
                  (option) => String(option?.utype) === "2"
              );
  
              const filteredUserData = data.filter(
                  (option) => String(option?.utype) === "1"
              );
              console.log(data);
  
              if (seller === "") {
                  setdistinctSeller(filteredData);
                  setdistinctuser(filteredUserData);
              }
  
              else {
                  setdistinctuser(filteredUserData);
              }
          } catch (error) {
              setshowprogress(false);
              console.error("API Request Error:", error.message);
          }
      };

    const CallDistinctAPIKey = async () => {

        try {
            setshowprogress(true);
            const apiUrl = `${BASE_URL}/DistinctAPIKey`;
            const requestBody = {
                guiuserid: sessionusertype === 1 ? sessionusername : guiuser,
            };
            const fetchOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },

                body: JSON.stringify(requestBody),
            };

            const response = await fetch(apiUrl, fetchOptions);
            if (!response.ok) {
                setshowprogress(false);
                console.log(`API request failed with status ${response.status}`);
                const result = await Swal.fire({
                    title: 'API Request Error',
                    html: ("Request Failed with Status:" + response.status),
                    icon: 'error'
                });

                if (result.isConfirmed) {
                    setDistinctAPIData([]);
                }
                return;
            }


            // Check if response is not empty before parsing as JSON
            const responseText = await response.text();
            let data;
            if (responseText) {
                data = JSON.parse(responseText);
            } else {
                data = [];
            }

            if (data?.length > 0) {
                setDistinctAPIData(data);
            } else {
                setDistinctAPIData([]);
            }
            console.log(data);
            setshowprogress(false);
        }

        catch (error) {
            console.error("API Request Error:", error.message);
            setshowprogress(false);

            const result = await Swal.fire({
                title: 'API Request Error',
                html: error.message,
                icon: 'error'
            });
            if (result.isConfirmed) {

            }
            return;
        }
    };

    const distinctIP = async () => {
        console.log("called distinct ip...");
        try {
            setshowprogress(true);
            const apiUrl = `${BASE_URL}/DistinctIP`;
            const requestBody = {
                guserid: { guiuserid: sessionusertype === 1 ? sessionusername : guiuser },
                GenertaedSkey: apikeyvalue
            };
            const fetchOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },

                body: JSON.stringify(requestBody),
            };

            const response = await fetch(apiUrl, fetchOptions);
            if (!response.ok) {
                setshowprogress(false);
                console.log(`API request failed with status ${response.status}`);
                const result = await Swal.fire({
                    title: 'API Request Error',
                    html: ("Request Failed with Status:" + response.status),
                    icon: 'error'
                });

                if (result.isConfirmed) {
                    setDistinctIPData([]);
                }
                return;
            }


            // Check if response is not empty before parsing as JSON
            const responseText = await response.text();
            let data;
            if (responseText) {
                data = responseText ? JSON.parse(responseText) : [];
                console.log("Parsed Response Data:", data);
            } else {
                data = [];
            }
            console.log("inside now:" + data?.ipaddress);
            if (data?.ipaddress) {
                setDistinctIPData(data);


            } else {
                setDistinctIPData([]);
                console.log("No Data");
            }
            console.log(data);
            setshowprogress(false);
        }

        catch (error) {
            console.error("API Request Error:", error.message);
            setshowprogress(false);

            const result = await Swal.fire({
                title: 'API Request Error',
                html: error.message,
                icon: 'error'
            });
            if (result.isConfirmed) {

            }
            return;
        }
    }

    const CalldownloadRequestAPI = async () => {
        try {
            console.log("calling download detailedreport")
            setshowprogress(true);
            if (!apikeyvalue || !ipvalue) {
                setshowprogress(false);
                const re = await Swal.fire({
                    title: "Value Error!",
                    text: "Please Fill All Field values as either API Key or IP  field not inputted",
                    icon: "error"
                })

                if (re.isConfirmed) {
                    setguiuser('');
                    setapikeyvalue('');
                    setDateRange([]);
                    setDateRangevalue("");


                }
            }

            else {
                const apiUrl = `${BASE_URL}/DownloadRequest`;
                const requestBody = {
                    filename: "DetailedReport",
                    ecode: null,
                    guser: {
                        requser: sessionusername,
                        guiuserid: sessionusertype === 1 ? sessionapiuser : guiuser,
                        seckey: {
                            GenertaedSkey: apikeyvalue
                        },
                    },
                    sdate: formatDate(startDate),
                    edate: formatDate(endDate),
                    ip: ipvalue,
                    mno:{
                        mobileno:mobilenumber
                    }
                };
                const fetchOptions = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },

                    body: JSON.stringify(requestBody),
                };

                const response = await fetch(apiUrl, fetchOptions);
                if (!response.ok) {
                    const errorMessage = response.statusText;
                    const responseBody = await response.text();
                    setshowprogress(false);
                    console.log(`API request failed with status ${response.status}`);
                    const result = await Swal.fire({
                        title: 'Download Request Error',
                        html: `${errorMessage}${responseBody}`,
                        icon: 'error'
                    });

                    if (result.isConfirmed) {
                        setDetailedapiData([]);
                        setDistinctAPIData([]);
                        setDistinctIPData([]);
                        setguiuser('');
                        setapikeyvalue(''); // Reset only when necessary
                        setipvalue('');
                        setDateRange([]);
                        setDateRangevalue("");

                        // Reset only when necessary
                    }
                    return;
                }

                else {
                    setshowprogress(false);
                    const result = await Swal.fire({
                        title: "Request Accepted Successfully!",
                        text: `Your Detailed Report Download Request is Accepted Successfully.Click on Top-Right Download Icon, to check Status and will get Download Link to download once file is available for Downloads.`,
                        icon: "success"
                    });

                    if (result.isConfirmed) {
                        setDetailedapiData([]);
                        setDistinctAPIData([]);
                        setDistinctIPData([]);
                        setguiuser('');
                        setapikeyvalue(''); // Reset only when necessary
                        setipvalue('');
                        setDateRange([]);
                        setDateRangevalue("");
                        // Reset only when necessary
                    }
                    return;
                }
            }
        }

        catch (error) {
            console.error("API Request Error:", error.message);
            setshowprogress(false);

            const result = await Swal.fire({
                title: 'Download request Error',
                html: error.message,
                icon: 'error'
            });
            if (result.isConfirmed) {
                setguiuser('');
                setapikeyvalue('');
                setDateRange([]);
                setDateRangevalue("");
            }
            return;
        }


    };

    useEffect(() => {
           if (sessionusertype === 0) {
               callDistinctGUIUser();
           }
   
           else {
               setguiuser(sessionapiuser);
                   CallDistinctAPIKey();
           }
   
       }, []);

           useEffect(() => {
               if (sessionusertype !== 2) {
                   callDistinctGUIUser();
               }
           }, []);
       
           useEffect(() => {
               if (seller !== "" || sessionusertype === 2) {
                   callDistinctGUIUser();
               }
           }, [seller, sessionusertype])
   
       useEffect(() => {
           if (guiuser !== "" && guiuser !== "All" && sessionusername !== guiuser ) {
               CallDistinctAPIKey();
           }
           if (guiuser === "All") {
               setapikeyvalue("All");
               setipvalue("All");
           } else {
               setapikeyvalue(""); // Reset apikeyvalue when guiuser changes
               setipvalue("");     // Reset ipvalue when guiuser changes
           }
       }, [guiuser]);
   
       useEffect(() => {
           if (apikeyvalue && apikeyvalue !== "All") {
               distinctIP();
           }
           if (apikeyvalue === "All") {
               setipvalue("All");
           }
   
           else {
               setipvalue("");
           }
       }, [apikeyvalue]);

    // Split the IP addresses into an array
    const ipList = DistinctIPData?.ipaddress?.split(',') || [];
    console.log("iplist:" + ipList);
    console.log("totalpage:" + totalPage);

    console.log("detailedreport:" + DetailedapiData);

    return (
        <div className="maincontent-outermost">
            <div className="div-container" style={{ position: "relative" }}>
                <div className="row-container">
                    <span>User Detailed Report</span>
                </div>

                  {showprogress && (
    <div className="spinner-overlay">
        <div className="custom-spinner"></div>
    </div>
)}

                <div className={showprogress === true ? "flex-div blurred" : "flex-div"} >
                     {sessionusertype === 0 && (
                            <div className="smallest-flex-div-first"  >

                                <label htmlFor="apiuser" >Select Seller</label>
                                {sessionusertype !== 1 ? (
                                    <select
                                        className="selectpicker form-control"
                                        value={seller}
                                        onChange={(e) => setseller(e.target.value)}
                                        style={{ textOverflow: "ellipsis", overflowWrap: "break-word", overflow: "hidden", whiteSpace: "nowrap" }}
                                    >
                                        <option value="" disabled >Select Seller</option>
                                        {distinctSeller?.map((option, index) => (
                                                <option
                                                    key={index}
                                                    value={option?.guiuserid}
                                                    style={{
                                                        textOverflow: "ellipsis",
                                                        overflowWrap: "break-word",
                                                        overflow: "hidden",
                                                        whiteSpace: "nowrap",
                                                        marginLeft: "-1rem"
                                                    }}
                                                >
                                                    {option?.guiuserid}
                                                </option>
                                            ))
                                        }
                                    </select>
                                ) : (
                                    <input type="text" className="form-control" value={sessionusername} disabled />
                                )}


                            </div>
                        )}


                    <div className="smallest-flex-div-first" >

                        <label htmlFor="Countrycode" >API User </label>
                        {sessionusertype !== 1 ? (
                                <select
                                    className="selectpicker form-control"
                                    value={guiuser}
                                    onChange={(e) => setguiuser(e.target.value)}
                                    style={{ textOverflow: "ellipsis", overflowWrap: "break-word", overflow: "hidden", whiteSpace: "nowrap" }}
                                >
                                    <option value="" disabled >Select User</option>
                                    {distinctuser?.map((option, index) => (
                                        <option
                                            key={index}
                                            value={option?.guiuserid}
                                            style={{
                                                textOverflow: "ellipsis",
                                                overflowWrap: "break-word",
                                                overflow: "hidden",
                                                whiteSpace: "nowrap",
                                                marginLeft: "-1rem"
                                            }}
                                        >
                                            {option?.guiuserid}
                                        </option>
                                    ))
                                    }
                                </select>
                            ) : (
                                <input type="text" className="form-control" value={sessionapiuser} disabled />
                            )}

                    </div>

                    <div className="smallest-flex-div-first"  >

                        <label htmlFor="Countrycode" >API Key </label>
                        <select
                            className="selectpicker form-control"
                            value={guiuser === "All" ? "All" : apikeyvalue}
                            onChange={(e) => setapikeyvalue(e.target.value)}
                            style={{
                                fontSize: "0.8rem",
                                textOverflow: "ellipsis",
                                overflowWrap: "break-word",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                            }}
                            disabled={guiuser === "All"} // Disable the dropdown if guiuser is "All"
                        >
                            <option value="" disabled>Select API Key</option>
                            <option value="All">All</option>
                            {DistinctAPIData?.map((option, index) => (
                                <option
                                    key={index}
                                    value={option?.genertaedSkey}
                                    style={{
                                        textOverflow: "ellipsis",
                                        overflowWrap: "break-word",
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                        marginLeft: "-1rem",
                                    }}
                                >
                                    {option?.genertaedSkey}
                                </option>
                            ))}
                        </select>

                    </div>

                    <div className="smallest-flex-div-first"  >
                        <label htmlFor="ip" >IP Address </label>
                        <select
                            className="selectpicker form-control"
                            disabled={guiuser === "All" || apikeyvalue === "All"}
                            value={(guiuser === "All" || apikeyvalue === "All") ? "All" : ipvalue}
                            onChange={handleChange}
                            style={{ textOverflow: "ellipsis", overflowWrap: "break-word", overflow: "hidden", whiteSpace: "nowrap" }}
                        >
                            <option>Select IP</option>
                            <option value="All">All</option>
                            {ipList?.map((ip, index) => (
                                <option key={index} value={ip}>{ip}</option>
                            ))}
                        </select>
                    </div>

                    <div className="smallest-flex-div-first">
                        <label>Mobile Number</label>

                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search By Mobile No."
                            value={mobilenumber}
                            onChange={handleMobileChange} // Only update state for valid mobile numbers
                            onKeyPress={handleKeyPress} // Restrict non-numeric keys
                            maxLength="10"
                        />

                    </div>

                    <div className='smallest-flex-div-first' style={{ marginTop: "0rem" }}>
                        <label htmlFor="date" >Date Range</label>
                        <RangePicker
                            value={daterangevalue}
                            size="large"
                            className='neuromorphic-input'
                            onChange={handleDateChange}
                            style={{ border: "1px dotted black", width: "100%", height: "2.3rem" }}
                            disabledDate={(current) => {
                                const fromDate = new Date(fromdate); // Replace with your actual fromdate
                                const today = new Date();
                                today.setHours(23, 59, 59, 999); // End of today's date

                                // Disable dates before `fromDate` and after today
                                return current && (current < fromDate || current > today);
                            }}
                        />
                    </div>
                </div>

                <div className={showprogress === true ? "row-container blurred" : "row-container"}>

                    <div className="button-file-div mt-2">
                        <button className='btn btn-dark mt-0' onClick={() => callDetailedReport(0)} >
                            <i class="fa-solid fa-file-lines mr-2"></i>
                            <span>View Report</span></button>
                        <button className='btn btn-dark ' onClick={CalldownloadRequestAPI}>
                            <i class="fa-solid fa-download mr-1"></i> <span>Download</span></button>
                    </div>

                </div>


                <div className={showprogress === true ? "row-container blurred" : "row-container"}>
                    {DetailedapiData === null ? (
                        <div className="rowcontainer" style={{ justifyContent: "center" }}>
                            <div className="spinner-container">
                                <PushSpinner size={20} color="black" />
                            </div>
                        </div>
                    ) : (
                        apiDataLength === 0 ? (
                            <div className="img-report-div mt-4">
                                <div className="img-div">
                                    <img src="images/NoReport.png" className="img-noreport" alt="No Report" />

                                </div>
                                <p style={{ marginLeft: "0rem", marginTop: "1rem", color: "grey" }}>
                                    No Report Found !!!
                                </p>
                            </div>
                        ) : (<div className="table-responsive ml-0 mr-0">
                            <div className="row-container table-responsive "
                            >
                                <table className="table table-hover table-bordered mt-4" >
                                    <thead style={{ backgroundColor: "skyblue" }}>
                                        <tr>
                                            <th>Request Date</th>
                                            <th>API User ID</th>
                                            <th>API Key</th>
                                            <th>IP Address</th>
                                            <th>Sender ID</th>
                                            <th>Mobile Number</th>
                                            <th>Received Time</th>
                                            <th>Delivery Status</th>

                                        </tr>
                                    </thead>

                                    <tbody>
                                        {DetailedapiData.map((data, index) => (
                                            <React.Fragment key={index}>
                                                <tr key={index} style={{ fontSize: "0.96rem" }}>
                                                    <td
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "space-around",
                                                            alignItems: "center",
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={() => handleIcon(index)}>
                                                        <i
                                                            className={index === clickedIndex ? `fas fa-angle-up` : "fa fa-angle-down"}
                                                            style={{
                                                                border: "1px solid white",
                                                                borderRadius: "50%",
                                                                padding: "0.1rem 0.2rem",
                                                                backgroundColor: "silver",
                                                                fontWeight: "800",
                                                                marginRight: "0.3rem",
                                                            }}
                                                        ></i>
                                                        {data?.reqdate}</td>
                                                        <td>{data?.fuser.guiuserid}</td>
                                                    <td>{data?.newip.genertaedSkey}</td>
                                                    <td>{data?.newip.ipaddress}</td>
                                                    <td>{data?.senderid}</td>
                                                    <td>{data?.mobileno}</td>
                                                    <td>{data?.rtime}</td>
                                                    <td>{data?.uerrordesc}</td>




                                                </tr>
                                                {index === clickedIndex && (
                                                    <tr >
                                                        <td colSpan={8}>

                                                            <div style={{ textAlign: "left" }}>
                                                                <div><span style={{ fontWeight: "700", textAlign: "left", fontSize: "0.9rem" }}>Transaction ID: </span> {data.transactionid}</div>
                                                                <div><span style={{ fontWeight: "700", textAlign: "left", fontSize: "0.9rem" }}>Template ID: </span> {data.templateid}</div>
                                                                <div><span style={{ fontWeight: "700", fontSize: "0.9rem" }}>Text Message: </span> {data.smstext}</div>
                                                                <div><span style={{ fontWeight: "700", fontSize: "0.9rem" }}>SMS PDU Count: </span> {data.pdu}</div>
                                                                <div><span style={{ fontWeight: "700", fontSize: "0.9rem" }}>Delivered time: </span> {data.ctime}</div>
                                                                <div><span style={{ fontWeight: "700", fontSize: "0.9rem" }}>Message Source:</span>{data.msgsrc}</div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="row-container mt-2 mb-2" >
                                <div className="left-page-div">
                                    <span
                                        className="dataTables_info spanning"
                                        id="DataTables_Table_0_info"
                                        role="status"
                                        aria-live="polite"

                                    >
                                        Showing {currentPage * pageSize + 1} to {currentPage * pageSize + (apiDataLength < pageSize ? apiDataLength : pageSize)}{" "}
                                        <span className="newspan" > from {totalentry} </span>
                                        entries

                                    </span>
                                </div>
                                <div className="right-page-div">
                                    <div className={`paginate_button page-item previous ${currentPage === 0
                                        ? "disabled"
                                        : ""
                                        }`}
                                        id="DataTables_Table_0_previous li">
                                        <a
                                            aria-controls="DataTables_Table_0"
                                            data-dt-idx="0"
                                            tabIndex="0"
                                            className="page-link "
                                            onClick={
                                                currentPage > 0
                                                    ? handlePrevious
                                                    : null
                                            }
                                        >
                                            {" "}
                                            Previous
                                        </a>
                                    </div>

                                    <div className="paginate_button page-item active">
                                        <button
                                            aria-controls="DataTables_Table_0"
                                            data-dt-idx="1"
                                            tabIndex="0"
                                            className="page-link"
                                            style={{ fontSize: "15px", backgroundColor: "rgb(67, 177, 221)" }}
                                        >
                                            {currentPage + 1}
                                        </button>
                                    </div>

                                    <div className={`paginate_button page-item next ${currentPage === totalPage - 1
                                        ? "disabled"
                                        : ""
                                        } `}
                                        id="DataTables_Table_0_next">
                                        <a
                                            aria-controls="DataTables_Table_0"
                                            data-dt-idx="0"
                                            tabIndex="0"
                                            className="page-link"
                                            onClick={
                                                currentPage === (totalPage - 1)
                                                    ? null
                                                    : handleNext
                                            }
                                        >
                                            Next
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        )
                    )}
                </div>
            </div>


        </div>
    );
}